<!-- hero -->
<uc-main-header
	[heading]="getTitle()"
	[description]="getDescription()"
	[backgroundStyle]="clearingEnabled ? 'bg-home-clearing' : 'bg-home'"
	customPadding="lg:py-28 2xl:py-40"
>
	<uc-course-search-bar
		[options]="degreeLevelOptions"
		(enter)="onNavigate($event)"
		[searchLocation]="headerSearchBar"
		data-cy="home-header-search-bar"
	/>

	<div class="inline-flex items-center gap-3 mt-10 text-white">
		<uc-users-solid-svg customStyles="text-white" />
		<p>
			@if (!clearingEnabled) {
				Trusted by 300k+ students every year.
			} @else {
				Used by 150,000 clearing students each year!
			}
		</p>
	</div>
</uc-main-header>

<div class="container">
	<!-- featured university -->
	@if (!clearingEnabled) {
		<uc-featured-university />
	}
	@if (clearingEnabled) {
		<!-- CLEARING prime providers -->
		<uc-prime-providers />

		<!-- CLEARING CTA -->
		<uc-engage-card-cta
			backgroundImage="/assets/img/all_clearing_info_cta.png"
			icon="book2.svg"
			iconText="{{ 'Discover Clearing ' + currentYear }}"
			[hideIconOnMobile]="false"
			cardTitle="All the Clearing Info you Need"
			description="{{
				'Find everything you need for Clearing ' +
					currentYear +
					', including quick course and uni searches, FAQs, and relevant advice articles.'
			}}"
			link="/courses/clearing"
			[ugSearchOrderPosition]="null"
			[cleSearchOrderPosition]="null"
		>
			<div class="grid grid-cols-1 -mt-4 md:-mt-0 md:flex">
				<a routerLink="/courses/clearing" class="blue-button">
					Click for clearing
				</a>
			</div>
		</uc-engage-card-cta>

		<!-- CLEARING PROMO SLOTS -->
		<uc-promo-slots
			[headline]="'Latest in Clearing ' + currentYear"
			[section]="1"
			type="clearing"
		/>

		<!-- CLEARING quick search -->
		<uc-popular-subjects ngSkipHydration [showButton]="false" />

		<!-- CLEARING download app -->
		<uc-download-app-cta product="clearing" />
	}
	@if (!clearingEnabled) {
		<!-- latest from uni compare -->
		<uc-promo-slots headline="Find the latest from Uni Compare" [section]="1" />

		<!-- dowload our app -->
		<uc-download-app-cta product="default" />

		<!-- recommended universities -->
		<uc-recommended-unis-grid
			componentName="UG Recommended Universities"
			product="undergraduate"
		/>
	}

	<!-- take our quiz -->
	<uc-engage-card-cta-degree-quiz />

	<!-- what's new at Uni Compare-->
	<uc-promo-slots
		[headline]="
			clearingEnabled ? 'Recommended by Uni Compare' : 'What\'s new at Uni Compare'
		"
		[section]="2"
		[type]="clearingEnabled ? 'clearing' : 'default'"
	/>

	<!-- CLEARING: search -->
	@if (clearingEnabled) {
		<uc-clearing-search />
	}

	<!-- university rankings -->
	<uc-engage-card-cta
		backgroundImageClass="bg-cta-top-100"
		[border]="false"
		icon="graduation-hat.svg"
		[iconText]="`UNIVERSITY RANKINGS ${currentRankingsYear}`"
		cardTitle="Discover the top 100 universities"
		link="/rankings/all"
		description="Ranked based on real student feedback, our rankings are based on the things students care about the most -  course quality, student life, student accommodation and employability."
		[ugSearchOrderPosition]="null"
		[cleSearchOrderPosition]="null"
	>
		<a class="inline-block w-full md:w-auto blue-button" routerLink="/rankings/all"
			>View University Rankings</a
		>
	</uc-engage-card-cta>

	<!-- engage with universities -->
	@if (!clearingEnabled) {
		<div class="divider">
			<h2 class="secondary-header">Engage with universities</h2>
			<div class="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-16">
				@for (info of ctaContent; track info) {
					<uc-static-card
						[title]="info.title"
						[desc]="info.desc"
						[image]="info.image"
						[link]="info.link"
						[external]="info.external"
						[uni]="info.params"
						customHeight="lg:h-72"
					/>
				}
			</div>
		</div>
	}

	<!-- CLEARING advice-->
	@if (clearingEnabled) {
		<uc-clearing-articles-carousel ngSkipHydration />
	}
</div>
